import axios from "@axios";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";

export default function useDmp(trans) {
  const toast = useToast();

  async function handleMultipleActions(item, vueInstance, tenantId = null) {
    try {
      // Generamos el HTML de los radios para cada acción
      const actionsHtml = item.data.actions
        .map((act, index) => {
          return `
            <div style="text-align:left;" class="px-3 mb-1 d-flex align-items-center">
              <input type="radio" name="selectedAction" id="action_${index}" value="${index}" />
              <label for="action_${index}" class="mb-0" style="margin-left: 0.2rem;">
                ${act.action_name}
              </label>
            </div>
          `;
        })
        .join("");

      const result = await vueInstance.$swal({
        // title: trans["messages.actions.apply_state"] + ` ${item.text}`,
        title: trans["messages.actions.apply_state"],
        icon: "warning",
        html: `
          <form id="formActions" style="display: flex; flex-direction: column; align-items: center;">
            ${actionsHtml}
          </form>
        `,
        showCancelButton: true,
        confirmButtonText: trans["messages.activate.confirm"],
        cancelButtonText: trans["actions.cancel"],
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
          title: "swal-title-sm mb-2",
          icon: "swal-icon-warning-sm",
          popup: "swal-narrow-modal",
        },
        buttonsStyling: false,
        didOpen: () => {
          const confirmButton = vueInstance.$swal.getConfirmButton();
          confirmButton.disabled = true;
          const form = document.getElementById("formActions");
          form.addEventListener("change", () => {
            const selected = form.querySelector('input[name="selectedAction"]:checked');
            confirmButton.disabled = !selected;
          });
        },
        preConfirm: () => {
          const form = document.getElementById("formActions");
          if (!form) return null;
          const checked = form.querySelector('input[name="selectedAction"]:checked');
          return checked ? parseInt(checked.value, 10) : null;
        },
      });

      // Si el usuario confirma la acción
      if (result.isConfirmed) {
        const selectedIndex = result.value;
        if (selectedIndex === null) {
          await vueInstance.$swal({
            title: trans["messages.actions.no_action_selected"],
            icon: "info",
          });
          return;
        }

        // Tomamos la acción elegida del array
        const chosenAction = item.data.actions[selectedIndex];
        if (!chosenAction) return;

        // Mostramos un toast de "cargando"
        const toastId = toast(
          {
            component: ToastificationContent,
            props: {
              title:
                trans["messages.actions.executing"] +
                ` ${chosenAction.action_name} ${trans["messages.actions.in"]} ${item.text}`,
              icon: "LoaderIcon",
              variant: "warning",
            },
            iconClass: "loader-icon-toast",
          },
          { timeout: false }
        );

        // Hacemos la llamada al URL de la acción elegida
        const { data } = await axios.get(chosenAction.url);

        // Avisamos al usuario que se ejecutó correctamente la acción
        await vueInstance.$swal({
          title: trans["messages.actions.executed_successfully"].replace(
            "{action}",
            chosenAction.action_name
          ),
          icon: "success",
        });

        // Actualizamos los datos en el store
        store.dispatch("grid/setAlarmsBridgeData", {
          data: { tenantId, alarmsBridgeId: item.idAlarmsBridgeTreeItem, action: item },
        });
      }
    } catch (error) {
      console.error("Error executing multiple action:", error.response);
      await vueInstance.$swal({
        title: error.response?.data?.data?.error || trans["messages.actions.error_executing"],
        icon: "error",
      });
    }
  }

  return { handleMultipleActions };
}
